const getSubscriptionsDetail = state => {
  return state.subscriptionsDetail;
};

export default { getSubscriptionsDetail };
